import { useContext, createContext } from 'react'
import type { TenantThemeConfig } from '../types/theme'

// Create Theme Context
export const TenantThemeContext = createContext<{
    themeConfig: TenantThemeConfig | null
    isLoading: boolean
    error: string | null
}>({
    themeConfig: null,
    isLoading: true,
    error: null
})

// Hook to use tenant theme config
export const useTenantThemeConfig = () => {
    const context = useContext(TenantThemeContext)
    if (!context) {
        throw new Error('useTenantThemeConfig must be used within a TenantThemeProvider')
    }
    return context
}
